import NumberInput, { type Props as NumberInputProps, type NumericValue } from "components/NumberInput";
import React, { useEffect } from "react";
import { useSemanticUiInputRef } from "utilities/hookutils";

interface Props extends Omit<NumberInputProps, "onChanged" | "onBlur" | "error" | "onEnterPressed" | "onEscPressed"> {
  autoFocus?: boolean
  onChange: (newValue: number) => void
  onEnterPressed: (newValue: number) => void
  onEscPressed?: () => void
}

const OptionalNumberInput = (props: Props) => {
  const semanticInputRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.autoFocus) {
      semanticInputRef.ref.current.focus();
    }
  }, []);

  const { onChange, onEnterPressed, onEscPressed, ...rest } = props;

  const onChanged = async (newValue: NumericValue) => {
    props.onChange(newValue.value);
  };

  return <NumberInput
    {...rest}
    innerRef={semanticInputRef.refSetter}
    onEnterPressed={(v) => onEnterPressed(v.value)}
    onEscPressed={onEscPressed}
    onChanged={onChanged}
  />;
};

export default OptionalNumberInput;